var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mfe-connect',{attrs:{"service-url":_vm.serviceUrl,"application-name":_vm.applicationName},on:{"ready":_vm.mountApp}},[_c('div',{ref:"entryPoint"})])}
var staticRenderFns = []

export { render, staticRenderFns }